import { fetchApi } from '@/services/api-client';

export const THAI_EVENTS_PATH = '/thai-events';

export type ThaiEvent = {
  id: number;
  title: string;
  imageUrl: string;
  month: number;
  day: number;
  windowDays: number;
  enabled: boolean;
};

export type CreateThaiEventData = {
  title: string;
  imageUrl?: string;
  month: number;
  day: number;
  windowDays: number;
  enabled?: boolean;
};

export type UpdateThaiEventData = Partial<CreateThaiEventData>;

export const thaiEventsApi = {
  getAll: () => fetchApi<ThaiEvent[]>(THAI_EVENTS_PATH),
  getById: (id: number) => fetchApi<ThaiEvent>(`${THAI_EVENTS_PATH}/${id}`),
  create: (data: CreateThaiEventData) =>
    fetchApi<ThaiEvent>(THAI_EVENTS_PATH, { method: 'POST', body: JSON.stringify(data) }),
  update: (id: number, data: UpdateThaiEventData) =>
    fetchApi<ThaiEvent>(`${THAI_EVENTS_PATH}/${id}`, { method: 'PUT', body: JSON.stringify(data) }),
  delete: (id: number) => fetchApi<{ success: boolean }>(`${THAI_EVENTS_PATH}/${id}`, { method: 'DELETE' }),
};
